const AppRoutesEnum = {
  HOME: '/',
  TOKEN: '/#token-sale',
  BOT_TRADING: '/bot-trading',
  ARBITRAGE: '/arbitrage',
  FAQ: '/#faq',
};
export default AppRoutesEnum;
